import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Sentry } from 'react-activity';
import Tooltip from '@material-ui/core/Tooltip';
import 'react-activity/dist/react-activity.css';
import AssignmentIcon from '@material-ui/icons/Assignment';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import BlurOnIcon from '@material-ui/icons/BlurOn';
import { clearUnreadCount, onWhiteBoardOpen } from '../../../action/SocketActions';
import { LevelTwoAdmin, Visit } from '../../../../utils/common/NamingTerms';
import { educatorWhiteboardOpen } from '../../../action/VideoCallAction';
import RecordingOption from './RecordingOption';
import TimerOption from './TimerOption';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';
import { clearWhiteboardDataForSession } from '../../../../utils/WhiteboardSessionStorage';
const OT = require('@opentok/client');

const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitVideoOption extends Component {
    static propTypes = {
        closeMessagePop: PropTypes.func,
        onEndCall: PropTypes.func,
        onLeaveSession: PropTypes.func,
        onRecord: PropTypes.func,
        isEndCallLoading: PropTypes.bool,
        showMessagePop: PropTypes.bool,
        isChatOpen: PropTypes.bool,
        unreadCount: PropTypes.number,
        isRecording: PropTypes.bool,
        onScreenShot: PropTypes.func,
        hasRecording: PropTypes.bool,
        isVideoButtonDisabled: PropTypes.bool,
        isAudioButtonDisabled: PropTypes.bool,
        showNotification: PropTypes.func,
        onToggleBackgroundBlur: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            muteVideo: true,
            muteVoice: true,
            backgroundBlur: false,
            isBlurLoading: false,
            raiseHand: true,
            shareScreen: false,
            screenSharePublisherValue: '',
            apikey: '',
            fullScreen: false,
            sessionId: '',
            whiteBoard: false,
            show: false,
        };
        this.onHide = this.onHide.bind(this);
        this.sessionEvents = {
            sessionConnected: () => {
                this.setState({ connected: true });
            },
            sessionDisconnected: () => {
                this.setState({ connected: false });
            },
        };
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.setState(
            {
                apikey: this.props.apikey,
                sessionId: this.props.sessionId,
            },
            () => {}
        );
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        if (
            typeof this.props.muteAudioSingleStudent === 'boolean' &&
            this.props.muteAudioSingleStudent !== prevProps.muteAudioSingleStudent
        ) {
            this.setState({
                muteVoice: this.props.muteAudioSingleStudent,
            });
        }
        if (
            typeof this.props.muteVideoSingleStudent === 'boolean' &&
            this.props.muteVideoSingleStudent !== prevProps.muteVideoSingleStudent
        ) {
            this.setState({
                muteVideo: this.props.muteVideoSingleStudent,
            });
        }
    }

    // onToggleBackgroundBlur
    onToggleBackgroundBlur() {
        const nextBlur = !this.state.backgroundBlur;
        this.setState({ isBlurLoading: true });
        this.props.onToggleBackgroundBlur(nextBlur, (success) => {
            this.setState({
                isBlurLoading: false,
                backgroundBlur: success ? nextBlur : this.state.backgroundBlur,
            });
        });
    }

    // onMute
    onMute() {
        const previousMuteVideo = this.state.muteVideo;
        const nextMuteVideo = !previousMuteVideo;

        // Update immediately for smoother button feedback, then rollback on failure.
        this.setState({ muteVideo: nextMuteVideo });
        this.props.onMuteVideo(previousMuteVideo, (callback) => {
            if (!callback) {
                this.setState({ muteVideo: previousMuteVideo });
            }
        });
    }

    // onMuteVoice
    onMuteVoice() {
        const previousMuteVoice = this.state.muteVoice;
        const nextMuteVoice = !previousMuteVoice;

        // Update immediately for smoother button feedback, then rollback on failure.
        this.setState({ muteVoice: nextMuteVoice });
        this.props.onMuteVoice(previousMuteVoice, (callback) => {
            if (!callback) {
                this.setState({ muteVoice: previousMuteVoice });
            }
        });
    }

    // onRaiseHand
    onRaiseHand() {
        const { raiseHand } = this.state;
        this.props.onRaiseHand(raiseHand, (callback) => {
            if (!callback) {
                this.setState({
                    raiseHand,
                });
            } else {
                this.setState({
                    raiseHand: !raiseHand,
                });
            }
        });
    }

    // onScreenShare
    onScreenShare() {
        OT.checkScreenSharingCapability(function (response) {
            if (!response.supported || response.extensionRegistered === false) {
                // This browser does not support screen sharing
                alert('Not Supported');
            } else {
            }
        });
        const { shareScreen } = this.state;
        this.props.onScreenShare(shareScreen, (callback) => {});
    }

    //onHide
    onHide(show) {
        this.setState({ show: show });
    }

    //onError
    onError = (err) => {
        this.setState({ error: `Failed to connect: ${err.message}` });
    };

    //handleWhiteboardToggle

    handleWhiteboardToggle = (callBack) => {
        console.log('callBack', callBack);
        const { visitId, showWhiteboard } = this.props;
        const newWhiteboardState = !showWhiteboard;

        let values = {
            visitId,
            isWhiteboardOpen: newWhiteboardState,
        };
        this.props.educatorWhiteboardOpen(values, (response) => {
            if (response) {
                callBack(response);
            }
        });
        this.props.handleWhiteboardToggle(newWhiteboardState);
    };

    // Shared phone-slash icon used by the end call / leave session buttons
    renderEndCallIcon() {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.3201 18.97C10.4601 19.08 10.6001 19.18 10.7501 19.29C11.8901 20.12 13.0401 20.78 14.1901 21.27C15.3401 21.76 16.4301 22 17.4501 22C18.1501 22 18.8001 21.87 19.4001 21.62C20.0101 21.37 20.5501 20.98 21.0401 20.44C21.3301 20.12 21.5501 19.78 21.7201 19.42C21.8901 19.06 21.9701 18.69 21.9701 18.33C21.9701 18.05 21.9101 17.8 21.8101 17.55C21.7001 17.3 21.5201 17.09 21.2601 16.91L17.9501 14.56C17.7001 14.39 17.4701 14.26 17.2501 14.17C17.0301 14.08 16.8301 14.04 16.6401 14.04C16.3901 14.04 16.1601 14.11 15.9301 14.25C15.7001 14.37 15.4601 14.56 15.2101 14.81L14.4501 15.56C14.3401 15.67 14.2101 15.73 14.0401 15.73C13.9501 15.73 13.8701 15.72 13.7901 15.69C13.7201 15.66 13.6601 15.63 13.6101 15.61C13.4201 15.51 13.2001 15.37 12.9601 15.19"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.73 13.22C10.21 12.69 9.73 12.16 9.28 11.64C8.84 11.12 8.53 10.69 8.35 10.36C8.33 10.3 8.3 10.24 8.27 10.16C8.25 10.08 8.24 10.01 8.24 9.93C8.24 9.77 8.29 9.64 8.4 9.53L9.16 8.74C9.4 8.5 9.59 8.26 9.72 8.03C9.86 7.8 9.93 7.56 9.93 7.32C9.93 7.13 9.88 6.92 9.79 6.71C9.7 6.49 9.57 6.26 9.39 6.01L7.07 2.74C6.89 2.48 6.66 2.3 6.4 2.18C6.15 2.06 5.87 2 5.59 2C4.85 2 4.15 2.31 3.51 2.94C2.98 3.44 2.6 4 2.36 4.61C2.12 5.21 2 5.86 2 6.54C2 7.58 2.24 8.67 2.72 9.81C3.2 10.94 3.86 12.08 4.68 13.22C5.51 14.36 6.44 15.45 7.47 16.49"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22 2L2 22"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    render() {
        const { muteVideo, muteVoice, fullScreen, raiseHand, backgroundBlur } = this.state;
        const sessionType = sessionStorage.getItem('SESSION_TYPE');
        const isInPersonOneToOne = sessionType === 'IN_PERSON';
        const {
            unreadCount,
            isRecording,
            isPatient,
            minWidth,
            minWidthHandle,
            hasRecording,
            isAllowAudioVideoChatBtn,
            isAllowEndVisitBtn,
            isShowChatBtn,
            isShowVideoConsultation,
            isBroadCast,
            isVideoButtonDisabled,
            isAudioButtonDisabled,
            isClassRoom,
            isWhiteboardOpen,
            hasUrlParamsAnonymousRole,
            sessionTypeParamsisOnetoOne,
            sessionEndTimeParamisGroupSession,
            isOwner,
            isChatOpen,
        } = this.props;
        const onlyAudioVideo = hasUrlParamsAnonymousRole;
        const showChat = !onlyAudioVideo || sessionEndTimeParamisGroupSession;
        const shouldShowUnreadBadge = unreadCount !== 0 && !isChatOpen;
        // console.log({
        //     onlyAudioVideo,
        //     sessionEndTimeParamisGroupSession,
        //     showChat,
        //     isPatient,
        //     isShowChatBtn,
        //     isAllowAudioVideoChatBtn,
        //     isInPersonOneToOne,
        // });
        return (
            <div
                className={`${this.state.fullScreen ? 'time-count-full-screen' : ''} ${
                    isBroadCast && isPatient && !minWidth
                        ? ''
                        : 'time-count clearfix z-index-1 flex justify-between items-center'
                }`}
            >
                <ul className="flex items-center justify-center gap-1 video-options sm:justify-start">
                    {!onlyAudioVideo && !isPatient && hasRecording && !isShowVideoConsultation && (
                        <li>
                            <button
                                id="demo-menu-top-left"
                                className="mdl-button mdl-js-button gray-btn mdl-button--fab"
                            >
                                <i className="material-icons">more_vert</i>
                            </button>
                            <ul
                                className="mdl-menu mdl-menu--top-left mdl-js-menu mdl-js-ripple-effect"
                                data-mdl-for="demo-menu-top-left"
                            >
                                <li
                                    className="mdl-menu__item"
                                    onClick={() => {
                                        this.props.onRecord();
                                    }}
                                >
                                    {isRecording
                                        ? this.props.t('stopRecord')
                                        : this.props.t('startRecord')}
                                </li>
                            </ul>
                        </li>
                    )}
                    {/* End Call */}
                    {!onlyAudioVideo &&
                        ((!isBroadCast && isAllowEndVisitBtn) ||
                            (isBroadCast && !isPatient) ||
                            (isBroadCast && isPatient && minWidth)) && (
                            <li>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {this.props.t('endVisit')} {Visit}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            onClick={() => {
                                                this.props.onEndCall();
                                                clearWhiteboardDataForSession(this.props.visitId);
                                            }}
                                            className="mdl-button mdl-js-button mdl-button--fab red-bg"
                                            disabled={
                                                this.props.isEndCallLoading ? 'disabled' : null
                                            }
                                        >
                                            {this.props.isEndCallLoading ? (
                                                <Sentry size={22} color="#FFF" />
                                            ) : (
                                                this.renderEndCallIcon()
                                            )}
                                        </button>
                                    </span>
                                </Tooltip>
                            </li>
                        )}
                    {/* Leave Session - Anonymous (third party) participants only */}
                    {onlyAudioVideo && (
                        <li>
                            <Tooltip
                                title={
                                    <span style={{ fontSize: '12px' }}>
                                        {this.props.t('leaveSession')}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>
                                    <button
                                        onClick={() => {
                                            this.props.onLeaveSession();
                                        }}
                                        className="mdl-button mdl-js-button mdl-button--fab red-bg"
                                    >
                                        {this.renderEndCallIcon()}
                                    </button>
                                </span>
                            </Tooltip>
                        </li>
                    )}
                    {/* Chat Option - Start */}
                    {showChat &&
                        !isPatient &&
                        !this.state.fullScreen &&
                        !minWidth &&
                        !isInPersonOneToOne &&
                        ((isShowChatBtn && isAllowAudioVideoChatBtn) || onlyAudioVideo) && (
                            <li className="relative z-index-1">
                                <div
                                    className={
                                        shouldShowUnreadBadge
                                            ? 'mdl-badge mdl-badge--overlap'
                                            : null
                                    }
                                    {...(shouldShowUnreadBadge && { 'data-badge': unreadCount })}
                                >
                                    <Tooltip
                                        title={
                                            <span style={{ fontSize: '12px' }}>
                                                {this.props.t('chat')}
                                            </span>
                                        }
                                        placement="top-start"
                                    >
                                        <span>
                                            <button
                                                className="mdl-button mdl-js-button blue-bg mdl-button--fab "
                                                onClick={
                                                    onlyAudioVideo
                                                        ? minWidthHandle
                                                        : this.props.openMessagePop
                                                }
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M22 6.25V11.35C22 12.62 21.58 13.69 20.83 14.43C20.09 15.18 19.02 15.6 17.75 15.6V17.41C17.75 18.09 16.99 18.5 16.43 18.12L15.46 17.48C15.55 17.17 15.59 16.83 15.59 16.47V12.4C15.59 10.36 14.23 9 12.19 9H5.39999C5.25999 9 5.13 9.01002 5 9.02002V6.25C5 3.7 6.7 2 9.25 2H17.75C20.3 2 22 3.7 22 6.25Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M15.59 12.4V16.47C15.59 16.83 15.55 17.17 15.46 17.48C15.09 18.95 13.87 19.87 12.19 19.87H9.47L6.45 21.88C6 22.19 5.39999 21.86 5.39999 21.32V19.87C4.37999 19.87 3.53 19.53 2.94 18.94C2.34 18.34 2 17.49 2 16.47V12.4C2 10.5 3.18 9.19002 5 9.02002C5.13 9.01002 5.25999 9 5.39999 9H12.19C14.23 9 15.59 10.36 15.59 12.4Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </li>
                        )}
                    {showChat && !isShowVideoConsultation && (
                        <>
                            {minWidth && isPatient && !isInPersonOneToOne && (
                                <li className="relative z-index-1">
                                    <div
                                        className={
                                            shouldShowUnreadBadge
                                                ? 'mdl-badge mdl-badge--overlap'
                                                : null
                                        }
                                        {...(shouldShowUnreadBadge && { 'data-badge': unreadCount })}
                                    >
                                        <Tooltip
                                            title={
                                                <span style={{ fontSize: '12px' }}>
                                                    {this.props.t('chat')}
                                                </span>
                                            }
                                            placement="top-start"
                                        >
                                            <span>
                                                <button
                                                    className="mdl-button mdl-js-button blue-bg mdl-button--fab "
                                                    onClick={minWidthHandle}
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M22 6.25V11.35C22 12.62 21.58 13.69 20.83 14.43C20.09 15.18 19.02 15.6 17.75 15.6V17.41C17.75 18.09 16.99 18.5 16.43 18.12L15.46 17.48C15.55 17.17 15.59 16.83 15.59 16.47V12.4C15.59 10.36 14.23 9 12.19 9H5.39999C5.25999 9 5.13 9.01002 5 9.02002V6.25C5 3.7 6.7 2 9.25 2H17.75C20.3 2 22 3.7 22 6.25Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M15.59 12.4V16.47C15.59 16.83 15.55 17.17 15.46 17.48C15.09 18.95 13.87 19.87 12.19 19.87H9.47L6.45 21.88C6 22.19 5.39999 21.86 5.39999 21.32V19.87C4.37999 19.87 3.53 19.53 2.94 18.94C2.34 18.34 2 17.49 2 16.47V12.4C2 10.5 3.18 9.19002 5 9.02002C5.13 9.01002 5.25999 9 5.39999 9H12.19C14.23 9 15.59 10.36 15.59 12.4Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </button>
                                            </span>
                                        </Tooltip>
                                    </div>
                                </li>
                            )}
                        </>
                    )}
                    {showChat && minWidth && !isInPersonOneToOne && (
                        <li className="relative z-index-1">
                            <div
                                className={
                                    shouldShowUnreadBadge
                                        ? 'mdl-badge mdl-badge--overlap'
                                        : null
                                }
                                {...(shouldShowUnreadBadge && { 'data-badge': unreadCount })}
                            >
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {this.props.t('chat')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className="mdl-button mdl-js-button blue-bg mdl-button--fab "
                                            onClick={
                                                onlyAudioVideo
                                                    ? minWidthHandle
                                                    : this.props.openMessagePop
                                            }
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M22 6.25V11.35C22 12.62 21.58 13.69 20.83 14.43C20.09 15.18 19.02 15.6 17.75 15.6V17.41C17.75 18.09 16.99 18.5 16.43 18.12L15.46 17.48C15.55 17.17 15.59 16.83 15.59 16.47V12.4C15.59 10.36 14.23 9 12.19 9H5.39999C5.25999 9 5.13 9.01002 5 9.02002V6.25C5 3.7 6.7 2 9.25 2H17.75C20.3 2 22 3.7 22 6.25Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M15.59 12.4V16.47C15.59 16.83 15.55 17.17 15.46 17.48C15.09 18.95 13.87 19.87 12.19 19.87H9.47L6.45 21.88C6 22.19 5.39999 21.86 5.39999 21.32V19.87C4.37999 19.87 3.53 19.53 2.94 18.94C2.34 18.34 2 17.49 2 16.47V12.4C2 10.5 3.18 9.19002 5 9.02002C5.13 9.01002 5.25999 9 5.39999 9H12.19C14.23 9 15.59 10.36 15.59 12.4Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )}
                    {/* Patient chat full screen view */}
                    {/* {!onlyAudioVideo && this.state.fullScreen && !isInPersonOneToOne && (
                        <li className="relative z-index-1">
                            <div
                                className={
                                    shouldShowUnreadBadge ? 'mdl-badge mdl-badge--overlap' : null
                                }
                                data-badge={unreadCount}
                            >
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {this.props.t('chat')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className="mdl-button mdl-js-button blue-bg mdl-button--fab "
                                            data-badge="1"
                                            onClick={() => {
                                                this.setState(
                                                    { fullScreen: !this.state.fullScreen },
                                                    () =>
                                                        this.props.onFullScreen(
                                                            this.state.fullScreen
                                                        )
                                                );
                                            }}
                                        >
                                            <i className="fa fa-comments" />
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )} */}
                    {/* Chat Option - End */}
                    {/* Particpants/Session Notes */}
                    {/* {!onlyAudioVideo &&
                        !isPatient &&
                        this.props.studentDetails?.tutor?.userId ===
                            JSON.parse(sessionStorage.getItem('userSession')).id && (
                            <li>
                                <div
                                    className={
                                        !this.props.showParticipants
                                            ? 'mdl-badge mdl-badge--overlap'
                                            : null
                                    }
                                >
                                    <Tooltip
                                        title={
                                            <span style={{ fontSize: '12px' }}>
                                                {this.props.userType === LevelTwoAdmin
                                                    ? this.props.t('participants')
                                                    : this.props.isClassRoom ||
                                                        this.props.isBroadCast
                                                      ? this.props.t('participantsSessionNotes')
                                                      : this.props.t('sessionNotes')}
                                            </span>
                                        }
                                        placement="top-start"
                                    >
                                        <span>
                                            <button
                                                className="mdl-button mdl-js-button blue-bg mdl-button--fab "
                                                data-badge="1"
                                                onClick={() => {
                                                    this.props.toggleParticipantsPop();
                                                    sessionStorage.setItem('messageSeen', false);
                                                }}
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M16.41 4C18.35 4 19.91 5.57 19.91 7.5C19.91 9.39 18.41 10.93 16.54 11C16.46 10.99 16.37 10.99 16.28 11"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M4.15997 14.56C1.73997 16.18 1.73997 18.82 4.15997 20.43C6.90997 22.27 11.42 22.27 14.17 20.43C16.59 18.81 16.59 16.17 14.17 14.56C11.43 12.73 6.91997 12.73 4.15997 14.56Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M18.3401 20C19.0601 19.85 19.7401 19.56 20.3001 19.13C21.8601 17.96 21.8601 16.03 20.3001 14.86C19.7501 14.44 19.0801 14.16 18.3701 14"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </li>
                        )} */}
                    {/* Whiteboard */}
                    {!onlyAudioVideo &&
                        !this.props.cancelScreenshare &&
                        !this.props.onhideWhiteBoard &&
                        !minWidth &&
                        this.props.userType !== LevelTwoAdmin &&
                        !isInPersonOneToOne && (
                            <>
                                {!isPatient && (
                                    <>
                                        {(!isClassRoom || !isPatient) && (
                                            <li>
                                                <Tooltip
                                                    title={
                                                        <span style={{ fontSize: '12px' }}>
                                                            {this.props.t('whiteboard')}
                                                        </span>
                                                    }
                                                    placement="top-start"
                                                >
                                                    <span>
                                                        <button
                                                            onClick={() => {
                                                                this.handleWhiteboardToggle();
                                                                // window.open(
                                                                //   "https://" +
                                                                //     window.location.hostname +
                                                                //     "/Educator/white/board"
                                                                // );
                                                            }}
                                                            className={`mdl-button mdl-js-button ${
                                                                this.props.isWhiteboardOpen
                                                                    ? 'red-bg'
                                                                    : 'blue-bg'
                                                            } mdl-button--fab`}
                                                        >
                                                            <svg
                                                                width="25"
                                                                height="24"
                                                                viewBox="0 0 25 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M20.5 8.25V18C20.5 21 18.71 22 16.5 22H8.5C6.29 22 4.5 21 4.5 18V8.25C4.5 5 6.29 4.25 8.5 4.25C8.5 4.87 8.74997 5.43 9.15997 5.84C9.56997 6.25 10.13 6.5 10.75 6.5H14.25C15.49 6.5 16.5 5.49 16.5 4.25C18.71 4.25 20.5 5 20.5 8.25Z"
                                                                    stroke="white"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M16.5 4.25C16.5 5.49 15.49 6.5 14.25 6.5H10.75C10.13 6.5 9.56997 6.25 9.15997 5.84C8.74997 5.43 8.5 4.87 8.5 4.25C8.5 3.01 9.51 2 10.75 2H14.25C14.87 2 15.43 2.25 15.84 2.66C16.25 3.07 16.5 3.63 16.5 4.25Z"
                                                                    stroke="white"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M8.5 13H12.5"
                                                                    stroke="white"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M8.5 17H16.5"
                                                                    stroke="white"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </button>
                                                    </span>
                                                </Tooltip>
                                            </li>
                                        )}
                                    </>
                                )}
                                {/* )} */}
                            </>
                        )}
                    {!onlyAudioVideo &&
                        this.props.onhideWhiteBoard &&
                        this.props.userType !== LevelTwoAdmin && (
                            <li>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {this.props.t('maximize')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            onClick={() => {
                                                this.props.onWhiteBoard();
                                            }}
                                            className="mdl-button mdl-js-button blue-bg mdl-button--fab"
                                        >
                                            <AssignmentIcon />
                                        </button>
                                    </span>
                                </Tooltip>
                            </li>
                        )}
                    {/* Video Enable / Disable */}
                    {isAllowAudioVideoChatBtn && (
                        <li>
                            <div>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {muteVideo
                                                ? this.props.t('enableVideo')
                                                : this.props.t('disableVideo')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className={
                                                muteVideo
                                                    ? 'mdl-button mdl-js-button red-bg mdl-button--fab flex items-center justify-center'
                                                    : 'mdl-button mdl-js-button blue-bg mdl-button--fab flex items-center justify-center'
                                            }
                                            disabled={
                                                // !this.props.streamAvailableStatus ||
                                                isVideoButtonDisabled
                                            }
                                            onClick={() => {
                                                this.onMute();
                                            }}
                                        >
                                            {muteVideo ? (
                                                <i className="material-icons">videocam_off</i>
                                            ) : (
                                                <svg
                                                    className="w-6 h-6"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M12.53 20.42H6.21C3.05 20.42 2 18.32 2 16.21V7.79C2 4.63 3.05 3.58 6.21 3.58H12.53C15.69 3.58 16.74 4.63 16.74 7.79V16.21C16.74 19.37 15.68 20.42 12.53 20.42Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M19.52 17.1L16.74 15.15V8.84001L19.52 6.89001C20.88 5.94001 22 6.52001 22 8.19001V15.81C22 17.48 20.88 18.06 19.52 17.1Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            )}
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )}
                    {/* Background Blur On / Off (only while the camera is on) */}
                    {isAllowAudioVideoChatBtn &&
                        !muteVideo &&
                        this.props.onToggleBackgroundBlur &&
                        window.OT?.hasMediaProcessorSupport?.() && (
                            <li>
                                <div>
                                    <Tooltip
                                        title={
                                            <span style={{ fontSize: '12px' }}>
                                                {backgroundBlur
                                                    ? this.props.t('removeBackgroundBlur')
                                                    : this.props.t('blurBackground')}
                                            </span>
                                        }
                                        placement="top-start"
                                    >
                                        <span>
                                            <button
                                                className={
                                                    backgroundBlur
                                                        ? 'mdl-button mdl-js-button red-bg mdl-button--fab flex items-center justify-center'
                                                        : 'mdl-button mdl-js-button blue-bg mdl-button--fab flex items-center justify-center'
                                                }
                                                disabled={this.state.isBlurLoading}
                                                onClick={() => {
                                                    this.onToggleBackgroundBlur();
                                                }}
                                            >
                                                <BlurOnIcon />
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </li>
                        )}
                    {/* Audio Enable / Disable */}
                    {(!isBroadCast || (isBroadCast && !isPatient)) && (
                        <li>
                            <div>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {muteVoice
                                                ? this.props.t('enableVoice')
                                                : this.props.t('disableVoice')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className={
                                                muteVoice
                                                    ? 'mdl-button mdl-js-button red-bg mdl-button--fab flex items-center justify-center'
                                                    : 'mdl-button mdl-js-button blue-bg mdl-button--fab flex items-center justify-center'
                                            }
                                            disabled={
                                                // !this.props.streamAvailableStatus ||
                                                isAudioButtonDisabled
                                            }
                                            onClick={() => {
                                                this.onMuteVoice();
                                            }}
                                        >
                                            {muteVoice ? (
                                                <i className="material-icons">mic_off</i>
                                            ) : (
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M4.3501 9.64999V11.35C4.3501 15.57 7.7801 19 12.0001 19C16.2201 19 19.6501 15.57 19.6501 11.35V9.64999"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M10.6101 6.43C11.5101 6.1 12.4901 6.1 13.3901 6.43"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11.2 8.55001C11.73 8.41001 12.28 8.41001 12.81 8.55001"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M12 19V22"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            )}
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )}
                    {/* Screen Share On / Off */}
                    {/* Screenshare: Available for all users in group sessions, disabled if someone is sharing */}
                    {((!onlyAudioVideo &&
                        (sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' ||
                            sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                            sessionStorage.getItem('VISIT_TYPE') === 'class_room_session' ||
                            sessionStorage.getItem('VISIT_TYPE') === 'conference_call')) ||
                        sessionEndTimeParamisGroupSession) &&
                        !minWidth &&
                        !isWhiteboardOpen &&
                        this.props.userType !== LevelTwoAdmin &&
                        !isInPersonOneToOne && (
                            <li
                                style={{
                                    cursor:
                                        this.props.hasScreenShare && !this.props.cancelScreenshare
                                            ? 'default'
                                            : 'pointer',
                                }}
                            >
                                <div>
                                    <Tooltip
                                        title={
                                            <span style={{ fontSize: '12px' }}>
                                                {this.props.cancelScreenshare
                                                    ? this.props.t('stopShare')
                                                    : this.props.hasScreenShare
                                                      ? this.props.t('screenShareInProgress')
                                                      : this.props.t('screenShare')}
                                            </span>
                                        }
                                        placement="top-start"
                                    >
                                        <span
                                            style={{
                                                cursor:
                                                    this.props.hasScreenShare &&
                                                    !this.props.cancelScreenshare
                                                        ? 'default'
                                                        : 'pointer',
                                            }}
                                        >
                                            <button
                                                className={
                                                    this.props.cancelScreenshare
                                                        ? 'mdl-button mdl-js-button red-bg mdl-button--fab flex items-center justify-center'
                                                        : 'mdl-button mdl-js-button blue-bg mdl-button--fab flex items-center justify-center'
                                                }
                                                style={
                                                    this.props.hasScreenShare &&
                                                    !this.props.cancelScreenshare
                                                        ? {
                                                              backgroundColor: '#7a8c89',
                                                              opacity: 0.6,
                                                              cursor: 'default',
                                                          }
                                                        : {}
                                                }
                                                onClick={() => {
                                                    this.onScreenShare();
                                                }}
                                                disabled={
                                                    this.props.hasScreenShare &&
                                                    !this.props.cancelScreenshare
                                                }
                                            >
                                                {this.props.cancelScreenshare ? (
                                                    <i className="material-icons">
                                                        stop_screen_share
                                                    </i>
                                                ) : (
                                                    <svg
                                                        width="25"
                                                        height="24"
                                                        viewBox="0 0 25 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6.94 2H18.05C21.61 2 22.5 2.89 22.5 6.44V12.77C22.5 16.33 21.61 17.21 18.06 17.21H6.94C3.39 17.22 2.5 16.33 2.5 12.78V6.44C2.5 2.89 3.39 2 6.94 2Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M12.5 17.22V22"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M2.5 13H22.5"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M8 22H17"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                )}
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </li>
                        )}
                    {/* Full Screen View On / Off */}
                    {(onlyAudioVideo || isOwner || isPatient) && !minWidth && !isBroadCast && (
                        <li>
                            <div>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {this.state.fullScreen
                                                ? this.props.t('exitFullScreen')
                                                : this.props.t('fullScreen')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className={
                                                this.state.fullScreen
                                                    ? 'mdl-button mdl-js-button red-bg mdl-button--fab'
                                                    : 'mdl-button mdl-js-button blue-bg mdl-button--fab'
                                            }
                                            onClick={() => {
                                                const willEnableFullScreen = !this.state.fullScreen;
                                                this.setState(
                                                    { fullScreen: willEnableFullScreen },
                                                    () => {
                                                        this.props.onFullScreen(
                                                            this.state.fullScreen
                                                        );
                                                    }
                                                );
                                            }}
                                        >
                                            {fullScreen ? (
                                                <FullscreenExitIcon />
                                            ) : (
                                                <i className="material-icons">fullscreen</i>
                                            )}
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )}
                    {/* Raisehand On / Off Classroom */}
                    {!onlyAudioVideo && isPatient && this.props.isClassRoom && (
                        <li>
                            <div>
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: '12px' }}>
                                            {raiseHand
                                                ? this.props.t('raiseYourHand')
                                                : this.props.t('lowerYourHand')}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        <button
                                            className={
                                                !raiseHand
                                                    ? 'mdl-button mdl-js-button red-bg mdl-button--fab'
                                                    : 'mdl-button mdl-js-button blue-bg mdl-button--fab'
                                            }
                                            onClick={() => {
                                                this.onRaiseHand();
                                            }}
                                        >
                                            <iconify-icon
                                                icon={
                                                    !raiseHand
                                                        ? 'pepicons-pop:hand-open-off'
                                                        : 'ic:outline-back-hand'
                                                }
                                                width="24"
                                                height="24"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            ></iconify-icon>
                                        </button>
                                    </span>
                                </Tooltip>
                            </div>
                        </li>
                    )}
                </ul>
                <div className="flex items-center gap-2 ml-auto">
                    {this.props.showTimer &&
                        (!sessionTypeParamsisOnetoOne ||
                            Number.isFinite(this.props.videoCallDetails?.durationLeft)) && (
                            <TimerOption
                                videoCallDetails={this.props.videoCallDetails}
                                studentDetails={this.props.studentDetails}
                                openVideoCallBufferAlert={() => {
                                    this.setState({
                                        endVideoCallFinalBufferAlert: false,
                                        endVideoCallBufferAlert: true,
                                    });
                                }}
                                openVideoCallFinalBufferAlert={() => {
                                    this.setState({
                                        endVideoCallBufferAlert: false,
                                        endVideoCallFinalBufferAlert: true,
                                    });
                                }}
                                sessionTypeParamsisOnetoOne={sessionTypeParamsisOnetoOne}
                                sessionEndTimeParamisGroupSession={
                                    sessionEndTimeParamisGroupSession
                                }
                            />
                        )}

                    <RecordingOption isRecording={isRecording} />
                </div>
            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        chatCount: state.VideoCallState.chatCount,
        isWhiteboardOpen: state.WhiteBoardReducerList.isWhiteboardOpen,
    };
};

const mapDispatchtoProps = (dispatch) => {
    return {
        clearUnreadCount: () => {
            dispatch(clearUnreadCount());
        },
        onWhiteBoardOpen: (input, callback) => {
            dispatch(onWhiteBoardOpen(input, callback));
        },
        educatorWhiteboardOpen: (values, callBack) => {
            dispatch(educatorWhiteboardOpen(values, callBack));
        },
    };
};

const ConnectedActiveVisitVideoOption = withLanguage(
    connect(mapStatetoProps, mapDispatchtoProps, null, { forwardRef: true })(ActiveVisitVideoOption)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedActiveVisitVideoOption {...props} />
    </LanguageProvider>
);
